import { useState } from "react";
import { X } from "lucide-react";
import api from "../../services/api";

export function ConsortiumFormModal({ item, clients, onClose, onSave }) {
  var isEdit = !!item;
  var formState = useState({
    client_id: item?.client_id || "",
    grupo: item?.grupo || "", cota: item?.cota || "",
    administrator: item?.administrator || "", status: item?.status || "ativo",
    value: item?.value || "", installment_value: item?.installment_value || "",
    installments_paid: item?.installments_paid || "", installments_total: item?.installments_total || "",
    details: item?.details || "", start_date: item?.start_date || "",
  });
  var form = formState[0]; var setForm = formState[1];
  var loadingState = useState(false);
  var errorState = useState(null);

  function updateField(f, v) { setForm(function(p) { var n = {}; for (var k in p) n[k] = p[k]; n[f] = v; return n; }); }

  async function handleSubmit(e) {
    e.preventDefault();
    if (!isEdit && !form.client_id) { errorState[1]("Selecione um cliente"); return; }
    loadingState[1](true); errorState[1](null);
    try {
      var payload = {
        client_id: form.client_id, grupo: form.grupo, cota: form.cota,
        administrator: form.administrator, status: form.status,
        value: form.value ? parseFloat(form.value) : 0,
        installment_value: form.installment_value ? parseFloat(form.installment_value) : 0,
        installments_paid: form.installments_paid ? parseInt(form.installments_paid) : 0,
        installments_total: form.installments_total ? parseInt(form.installments_total) : 0,
        details: form.details, start_date: form.start_date,
      };
      if (isEdit) { await api.put("/consortiums/" + item.id, payload); }
      else { await api.post("/consortiums", payload); }
      onSave();
    } catch(err) {
      var detail = err.response?.data?.detail || "Erro ao salvar";
      errorState[1](typeof detail === "string" ? detail : "Erro ao salvar");
    } finally { loadingState[1](false); }
  }

  return (
    <>
      <div className="fixed inset-0 bg-black/40 z-50" onClick={onClose} />
      <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50 w-full max-w-lg" data-testid="consortium-form-modal">
        <div className="bg-white rounded-2xl shadow-2xl max-h-[85vh] overflow-y-auto">
          <div className="flex items-center justify-between p-5 border-b border-gray-100">
            <h2 className="text-lg font-bold text-[#0A2F3D]">{isEdit ? "Editar Consorcio" : "Novo Consorcio"}</h2>
            <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-lg"><X className="w-5 h-5 text-gray-500" /></button>
          </div>
          {errorState[0] && <div className="mx-5 mt-3 px-4 py-2.5 rounded-lg text-sm bg-red-50 text-red-700 border border-red-200">{errorState[0]}</div>}
          <form onSubmit={handleSubmit} className="p-5 space-y-4">
            {!isEdit && (
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1.5">Cliente *</label>
                <select value={form.client_id} onChange={function(e) { updateField("client_id", e.target.value); }}
                  className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm bg-white focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30"
                  required data-testid="consortium-form-client">
                  <option value="">Selecione o cliente...</option>
                  {clients.map(function(c) { return <option key={c.id} value={c.id}>{c.name} ({c.email})</option>; })}
                </select>
              </div>
            )}
            <div className="grid grid-cols-3 gap-3">
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1.5">Grupo</label>
                <input type="text" value={form.grupo} onChange={function(e) { updateField("grupo", e.target.value); }}
                  className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30"
                  placeholder="Ex: 1234" data-testid="consortium-form-grupo" />
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1.5">Cota</label>
                <input type="text" value={form.cota} onChange={function(e) { updateField("cota", e.target.value); }}
                  className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30"
                  placeholder="Ex: 56" data-testid="consortium-form-cota" />
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1.5">Status</label>
                <select value={form.status} onChange={function(e) { updateField("status", e.target.value); }}
                  className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm bg-white focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30"
                  data-testid="consortium-form-status">
                  <option value="ativo">Ativo</option>
                  <option value="contemplado">Contemplado</option>
                  <option value="em_atraso">Em Atraso</option>
                  <option value="cancelado">Cancelado</option>
                </select>
              </div>
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1.5">Administradora</label>
              <input type="text" value={form.administrator} onChange={function(e) { updateField("administrator", e.target.value); }}
                className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30"
                placeholder="Ex: Rodobens, Porto Seguro" data-testid="consortium-form-admin" />
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1.5">Valor da Carta (R$)</label>
                <input type="number" value={form.value} onChange={function(e) { updateField("value", e.target.value); }}
                  className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30"
                  placeholder="0" step="0.01" data-testid="consortium-form-value" />
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1.5">Parcela (R$)</label>
                <input type="number" value={form.installment_value} onChange={function(e) { updateField("installment_value", e.target.value); }}
                  className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30"
                  placeholder="0" step="0.01" data-testid="consortium-form-installment" />
              </div>
            </div>
            <div className="grid grid-cols-3 gap-3">
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1.5">Parcelas Pagas</label>
                <input type="number" value={form.installments_paid} onChange={function(e) { updateField("installments_paid", e.target.value); }}
                  className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30"
                  placeholder="0" data-testid="consortium-form-paid" />
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1.5">Total Parcelas</label>
                <input type="number" value={form.installments_total} onChange={function(e) { updateField("installments_total", e.target.value); }}
                  className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30"
                  placeholder="0" data-testid="consortium-form-total" />
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-600 mb-1.5">Data Inicio</label>
                <input type="text" value={form.start_date} onChange={function(e) { updateField("start_date", e.target.value); }}
                  className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30"
                  placeholder="01/2024" data-testid="consortium-form-date" />
              </div>
            </div>
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1.5">Observacoes</label>
              <textarea value={form.details} onChange={function(e) { updateField("details", e.target.value); }}
                className="w-full px-3.5 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#3B82F6]/30 resize-none"
                rows="2" placeholder="Detalhes..." data-testid="consortium-form-details" />
            </div>
            <div className="flex gap-3 pt-1">
              <button type="button" onClick={onClose} className="flex-1 px-4 py-2.5 border border-gray-200 rounded-xl text-sm font-medium text-gray-600 hover:bg-gray-50">Cancelar</button>
              <button type="submit" disabled={loadingState[0]} className="flex-1 px-4 py-2.5 bg-[#3B82F6] text-white rounded-xl text-sm font-medium hover:bg-[#2563EB] disabled:opacity-50" data-testid="consortium-form-submit">
                {loadingState[0] ? "Salvando..." : isEdit ? "Salvar" : "Cadastrar"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export function DeleteConsortiumModal({ item, onClose, onConfirm }) {
  var loadingState = useState(false);
  async function handleDelete() { loadingState[1](true); await onConfirm(item.id); loadingState[1](false); }
  return (
    <>
      <div className="fixed inset-0 bg-black/40 z-50" onClick={onClose} />
      <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-50 w-full max-w-sm" data-testid="delete-consortium-modal">
        <div className="bg-white rounded-2xl shadow-2xl p-6">
          <h3 className="text-lg font-bold text-[#0A2F3D] mb-2">Excluir Consorcio</h3>
          <p className="text-sm text-gray-500 mb-5">Excluir consorcio de <strong>{item.client_name}</strong> (Grupo {item.grupo}, Cota {item.cota})?</p>
          <div className="flex gap-3">
            <button onClick={onClose} className="flex-1 px-4 py-2.5 border border-gray-200 rounded-xl text-sm font-medium text-gray-600 hover:bg-gray-50">Cancelar</button>
            <button onClick={handleDelete} disabled={loadingState[0]}
              className="flex-1 px-4 py-2.5 bg-red-500 text-white rounded-xl text-sm font-medium hover:bg-red-600 disabled:opacity-50"
              data-testid="delete-consortium-confirm">{loadingState[0] ? "Excluindo..." : "Excluir"}</button>
          </div>
        </div>
      </div>
    </>
  );
}
